import React from 'react';
//import BusinessCard from './BusinessCard';
import { useNavigate } from "react-router-dom";
//import { BusinessCardData } from '../../data/CardData';

const BusinessMraCardList = () => {
    const Role = sessionStorage.getItem('Role')
    // console.log("abc",Role);

    const navigate = useNavigate()
    const redirectDashboardPage = () => {
        navigate('/dashboard')
    }
    // const redirectPgBusinessDashboard = () => {
    //     navigate("/businessMyDashboard")
    // }

    // const redirectPgBusinessShowAllMeetings = () => {
    //     navigate("/businessShowAllMeetings")
    // }
    // const redirectPgBusinessContact = () => {
    //     navigate("/businessContactPg")
    // }
    // const redirectPgBusinessLead = () => {
    //     navigate("/businessLeadPg")
    // }
    // const redirectPgBusinessOpportunity = () => {
    //     navigate("/businessOpportunityPg")
    // }
    // const redirectPgBusinessCaf = () => {
    //     navigate("/businessCaf")
    // }
    const redirectbusinessShowAllMeetings = () => {
        navigate("/businessMraAllMeetings")
    }
    const redirectBusinessBdrPgContact = () => {
        navigate("/businessBdrPgAllContact")
    }
    const redirectBusinessBdrOfficeContact = () => {
        navigate("/businessBdrOfficeAllContact")
    }
    const redirectBusinessMraHotel = () => {
        navigate("/businessMraAllContactHotel")
    }



    return (
        <>
            <div className="container-fluid text-light Header-style header">
                <div className="p-3">
                    <span className='' style={{ cursor: 'pointer' }} onClick={redirectDashboardPage}>
                        <i className="fa-solid fa-arrow-left-long"></i>
                    </span>
                    <span className='p-1 m-3'>Menu</span>
                </div>
            </div>
            <div className="container-fluid Business-main">
                <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                    {/* {BusinessCardData.map((data, id) => (
                        <div className="col" key={id} onClick={() => redirectBusinessPage(data.path)}>
                            <BusinessCard title={data.title} />
                        </div>
                    ))} */}
                    <>
                        <div className="col">
                            <div className="card mb-3 mt-2 shadow-sm" onClick={redirectbusinessShowAllMeetings}>
                                <div className="m-2 " style={{ display: "inline-flex" }}>
                                    <p className="card-text overflow-hidden">All Business Meetings</p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card mb-3 mt-2 shadow-sm" onClick={redirectBusinessBdrOfficeContact}>
                                <div className="m-2 " style={{ display: "inline-flex" }}>
                                    <p className="card-text overflow-hidden">Office Market Research</p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card mb-3 mt-2 shadow-sm" onClick={redirectBusinessBdrPgContact}>
                                <div className="m-2 " style={{ display: "inline-flex" }}>
                                    <p className="card-text overflow-hidden">PG Market Research</p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card mb-3 mt-2 shadow-sm" onClick={redirectBusinessMraHotel}>
                                <div className="m-2 " style={{ display: "inline-flex" }}>
                                    <p className="card-text overflow-hidden">Hotel Market Research</p>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col">
                                <div className="card mb-3 mt-2 shadow-sm" onClick={redirectPgBusinessDashboard}>
                                    <div className="m-2 " style={{ display: "inline-flex" }}>
                                        <p className="card-text overflow-hidden">My Dashboard</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col">
                                <div className="card mb-3 mt-2 shadow-sm" onClick={redirectPgBusinessShowAllMeetings}>
                                    <div className="m-2 " style={{ display: "inline-flex" }}>
                                        <p className="card-text overflow-hidden">All Business Meetings</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col">
                                <div className="card mb-3 mt-2 shadow-sm" onClick={redirectPgBusinessContact}>
                                    <div className="m-2 " style={{ display: "inline-flex" }}>
                                        <p className="card-text overflow-hidden">Contact Management</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="card mb-3 mt-2 shadow-sm" onClick={redirectPgBusinessLead}>
                                    <div className="m-2 " style={{ display: "inline-flex" }}>
                                        <p className="card-text overflow-hidden">Lead</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="card mb-3 mt-2 shadow-sm" onClick={redirectPgBusinessOpportunity}>
                                    <div className="m-2 " style={{ display: "inline-flex" }}>
                                        <p className="card-text overflow-hidden">Opportunity</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="card mb-3 mt-2 shadow-sm" onClick={redirectPgBusinessCaf}>
                                    <div className="m-2 " style={{ display: "inline-flex" }}>
                                        <p className="card-text overflow-hidden">CAF</p>
                                    </div>
                                </div>
                            </div> */}


                    </>
                </div>
            </div>
        </>
    );
}

export default BusinessMraCardList;
